(function($){

	/*
	$('.toggleTabContent').on('click', function (event) {
		event.preventDefault();
		history.pushState("", "", window.location.href.split("#")[0] + $(this).attr('href'))
		var tab_id = $(this).attr('href');

		$('.tabItem, .tabContent').removeClass('active');
		$(this).parent().addClass('active');
		$(tab_id).addClass('active');

	});

	var hash = $.trim(window.location.hash);
	if (hash) $('.toggleTabContent[href$="'+ hash +'"]').trigger('click');
	*/

	$('.tabItems a').on('click', function (event) {
		event.preventDefault();
		//history.pushState("", "", window.location.href.split("#")[0] + $(this).attr('href'))
		var tab_id = $(this).attr('href');

		$('.tabItems li, .tabContents div').removeClass('active');
		$(this).parent().addClass('active');
		$(tab_id).addClass('active');
	});

	$('.tabNext').on('click', function (event) {
		event.preventDefault();
		$(this).parent().find("li.active").next().find("a").trigger('click');
	});
	$('.tabPrev').on('click', function (event) {
		event.preventDefault();
		$(this).parent().find("li.active").prev().find("a").trigger('click');
	});
	
	var hash = $.trim(window.location.hash);
	if (hash) $('[href$="'+ hash +'"]').trigger('click');
	
})(jQuery)

